<template>
  <div class="home">
    <navBar />

    <div class="main-container">
      <!-- 轮播图 -->
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="@/assets/images/home/banner.jpg">
          </div>
          <!-- <div class="swiper-slide">
            <img src="@/assets/images/home/banner.jpg">
          </div> -->
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <!-- 核心产品 -->
      <div class="pro-container">
        <h1>核心产品</h1>
        <span class="line"></span>
        <h2>全面支持零售企业数字化升级技术</h2>
        <div class="content">
          <div class="box" @click="go('/crm')">
            <img src="@/assets/images/home/crm-scrm.png" />
            <span class="line"></span>
            <p class="title">CRM & SCRM</p>
            <p class="des">会员规则管理，包括等级、积分、权益管理；社区体系，打造会员运营场景，增强客户体验与品牌忠诚度。</p>
            <div class="more">MORE</div>
          </div>
          <div class="box" @click="go('/marketingPlatform')">
            <img src="@/assets/images/home/marketing.png" />
            <span class="line"></span>
            <p class="title">智能营销平台</p>
            <p class="des">
              通过目标与功能配置，实现精准营销与多场景自动化营销，抓住营销机会，精准触达目标用户，并追踪营销效果。
            </p>
            <div class="more">MORE</div>
          </div>
          <div class="box" @click="go('/weChat')">
            <img src="@/assets/images/home/company-wechat.png" />
            <div class="line"></div>
            <p class="title">企业微信应用</p>
            <p class="des">
              基于企业微信搭建的零售与销售管理系统。通过客户数据管理，任务管理等方法提高复购与业务转化率。
            </p>
            <div class="more">MORE</div>
          </div>
          <div class="box" @click="go('/datePlatform')">
            <img src="@/assets/images/home/customer-data.png" />
            <span class="line"></span>
            <p class="title">客户数据平台</p>
            <p class="des">
              打通客户多渠道数据，包括第三方电商平台、POS、OMS、ERP等系统。融合多渠道身份ID，会员模型建设，标签计算，业务推荐等。
            </p>
            <div class="more">MORE</div>
          </div>
        </div>
      </div>

      <!-- 业务服务 -->
      <div class="business-container">
        <h1>业务服务</h1>
        <span class="line"></span>
        <div class="content">
          <div class="box blue-bg">
            <img src="@/assets/images/home/policy-service.png">
            <span class="line"></span>
            <p class="title">策略服务</p>
            <p class="des">• 客户渠道数字化体验策略与设计</p>
            <p class="des">• 会员体系与业务流程设计</p>
            <p class="des">• 多渠道客户管理策略</p>
            <p class="des">• 客户招募策略</p>
          </div>
          <div class="box">
            <img src="@/assets/images/home/vip-crm.png">
            <span class="line"></span>
            <p class="title">会员CRM运营</p>
            <p class="des">• 会员体系运营管理</p>
            <p class="des">• 会员生命周期管理</p>
            <p class="des">• 会员个性化体验管理</p>
          </div>
          <div class="box blue-bg">
            <img src="@/assets/images/home/ugc.png">
            <span class="line"></span>
            <p class="title">UGC社区运营</p>
            <p class="des">• 会员UGC运营计划</p>
            <p class="des">• UGC内容规划引导</p>
            <p class="des">• 会员奖励与任务体系运营</p>
          </div>
          <div class="box">
            <img src="@/assets/images/home/marketing-creativity.png">
            <span class="line"></span>
            <p class="title">营销创意与精准投放</p>
            <p class="des">• 会员标签体系设计</p>
            <p class="des">• 会员精准分组管理</p>
            <p class="des">• 会员自动化营销规则设计</p>
            <p class="des">• 营销效果追踪与分析</p>
          </div>
          <div class="box blue-bg">
            <img src="@/assets/images/home/data-service.png">
            <span class="line"></span>
            <p class="title">数据服务</p>
            <p class="des">• 客户数据、运营数据分析</p>
            <p class="des">• 系统日志数据整合分析</p>
            <p class="des">• 客户数据价值挖掘</p>
            <p class="des">• 数据模型建设</p>
          </div>
        </div>
      </div>

      <!-- 我们服务的品牌 -->
      <div class="brand-container">
        <h1>我们服务的品牌</h1>
        <span class="line"></span>
        <h2>覆盖美妆、消费品、轻奢、汽车和母婴等行业</h2>
        <div class="content">
          <div class="box">
            <div class="item" @mouseover="showActiveImg(1)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/loreal.jpg" v-if="index === 1">
              <img src="@/assets/images/home/small/unactive/loreal.jpg" v-else>
              <span></span>
            </div>
            <div class="item" @mouseover="showActiveImg(2)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/winona.jpg" v-if="index === 2">
              <img src="@/assets/images/home/small/unactive/winona.jpg" v-else>
              <span></span>
            </div>
            <div class="item" @mouseover="showActiveImg(3)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/ck.jpg" v-if="index === 3">
              <img src="@/assets/images/home/small/unactive/ck.jpg" v-else>
              <span></span>
            </div>
            <div class="item" @mouseover="showActiveImg(4)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/tommyhilfige.jpg" v-if="index === 4">
              <img src="@/assets/images/home/small/unactive/tommyhilfige.jpg" v-else>
              <span></span>
            </div>
            <div class="item" @mouseover="showActiveImg(5)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/bruichladdich.jpg" v-if="index === 5">
              <img src="@/assets/images/home/small/unactive/bruichladdich.jpg" v-else>
              <span></span>
            </div>
            <div class="item" @mouseover="showActiveImg(6)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/Cadillac.jpg" v-if="index === 6">
              <img src="@/assets/images/home/small/unactive/Cadillac.jpg" v-else>
            </div> 
          </div>
          <div class="box">
            <div class="item" @mouseover="showActiveImg(7)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/maybelline.jpg" v-if="index === 7">
              <img src="@/assets/images/home/small/unactive/maybelline.jpg" v-else>
              <span></span>
            </div>
            <div class="item" @mouseover="showActiveImg(8)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/mariedalgar.jpg" v-if="index === 8">
              <img src="@/assets/images/home/small/unactive/mariedalgar.jpg" v-else>
              <span></span>
            </div>
            <div class="item" @mouseover="showActiveImg(9)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/gteinal.jpg" v-if="index === 9">
              <img src="@/assets/images/home/small/unactive/gteinal.jpg" v-else>
              <span></span>
            </div>
            <div class="item" @mouseover="showActiveImg(10)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/kans.jpg" v-if="index === 10">
              <img src="@/assets/images/home/small/unactive/kans.jpg" v-else>
              <span></span>
            </div>
            <div class="item" @mouseover="showActiveImg(11)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/ermymartin.jpg" v-if="index === 11">
              <img src="@/assets/images/home/small/unactive/ermymartin.jpg" v-else>
              <span></span>
            </div>
            <div class="item" @mouseover="showActiveImg(12)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/volvo.jpg" v-if="index === 12">
              <img src="@/assets/images/home/small/unactive/volvo.jpg" v-else>
            </div> 
          </div>
          <div class="box">
            <div class="item" @mouseover="showActiveImg(13)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/3ce.jpg" v-if="index === 13">
              <img src="@/assets/images/home/small/unactive/3ce.jpg" v-else>
              <span></span>
            </div>
            <div class="item" @mouseover="showActiveImg(14)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/haier.jpg" v-if="index === 14">
              <img src="@/assets/images/home/small/unactive/haier.jpg" v-else>
              <span></span>
            </div>
            <div class="item" @mouseover="showActiveImg(15)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/qiaohu.jpg" v-if="index === 15">
              <img src="@/assets/images/home/small/unactive/qiaohu.jpg" v-else>
              <span></span>
            </div>
            <div class="item" @mouseover="showActiveImg(16)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/casio.jpg" v-if="index === 16">
              <img src="@/assets/images/home/small/unactive/casio.jpg" v-else>
              <span></span>
            </div>
            <div class="item" @mouseover="showActiveImg(17)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/hennessy.jpg" v-if="index === 17">
              <img src="@/assets/images/home/small/unactive/hennessy.jpg" v-else>
              <span></span>
            </div>
            <div class="item" @mouseover="showActiveImg(18)" @mouseout="index = ''">
              <img src="@/assets/images/home/small/active/evcard.jpg" v-if="index === 18">
              <img src="@/assets/images/home/small/unactive/evcard.jpg" v-else>
            </div> 
          </div>
        </div>
      </div>

      <div class="btn-container">
        <div class="btn-customer" @click="go('/caseCar?type=0')">合作案例</div>
        <div class="btn-business" @click="dialogFormVisible = true">业务咨询与市场合作</div>
      </div>
    </div>

    <footerBar />
    <!-- 置顶 -->
    <scrollTop />

    <el-dialog
      title="业务咨询与市场合作"
      :close-on-click-modal = "false"
      :close-on-press-escape = "false"
      :visible.sync="dialogFormVisible"
      width="550px" 
      @close="close"
    >
      <el-form :model="form" :rules="rules" ref="form" > 
        <el-form-item  prop="name">
          <span>*</span>
          <el-input v-model="form.name" autocomplete="off" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item   prop="company">
          <span>*</span>
          <el-input v-model="form.company" autocomplete="off" placeholder="公司"></el-input>
        </el-form-item>
        <el-form-item  prop="mobile">
          <span>*</span>
          <el-input v-model.number="form.mobile" autocomplete="off"  placeholder="联系电话"  maxlength="11"></el-input>
        </el-form-item>
        <el-form-item  prop="mail">
          <span>*</span>
          <el-input v-model="form.mail" autocomplete="off" placeholder="邮箱"></el-input>
        </el-form-item>
        <el-form-item  prop="content">
          <span>*</span>
          <el-input
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 5}"
            placeholder="请输入内容"
            v-model="form.content"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="disabled" type="primary" @click="sure('form')">确 定</el-button>
        <!-- <span>提交后，信息转入邮箱 marketing@indation.com</span> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import navBar from "@/components/nav-bar";
import footerBar from "@/components/footer-bar";
import scrollTop from "@/components/scroll-top";
import config from "@/assets/config.json";

export default {
  name: "home",
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    }
    return {
      index: "",
      dialogFormVisible: false,
      form: {
          company: "",
          content: "",
          mail: "",
          mobile: "",
          name: ""
      },
      disabled: false,
      formLabelWidth: '120px',
      rules: {
        company: [
          { required: true, message: '请填写公司', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请填写内容', trigger: 'blur' }
        ],
        mail: [
          { required: true, message: '请填写邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        mobile: [
          { validator:checkPhone,trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请填写姓名', trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    navBar,
    footerBar,
    scrollTop
  },
  mounted() {
    new Swiper ('.swiper-container', {
      loop: true,   
      autoplay: false,//可选选项，自动滑动
      // pagination : '.swiper-pagination',
      // paginationType : 'bullets',
    })   
  },
  methods: {
    showActiveImg(index) {
      this.index = index;
    },
    // 业务咨询与市场合作 提交
    sure(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            this.disabled = true;
            this.$axios({
              method:'post',
              // url:'https://tst-phd.remycn.com/octomore-sms/octomore/mail',
              url: `${config.api.api}/indation/common/mail`,
              data: this.form
            }).then((response) =>{  
              if(response.data.code === 200){
                this.dialogFormVisible = false;
                this.$message.success('提交成功');
                this.disabled = false;
              } else {
                this.$message.error('提交失败');
                this.disabled = false;
                return false;
              }
            }).catch((error) => {
              this.$message.error(error); //请求失败返回的数据
              this.disabled = false;
            })
          } else {
            this.$message.warning('请将内容填写完整') //请求失败返回的数据
            this.disabled = false;
            return false;
          }
        });
    },
    close(){
        this.$refs.form.clearValidate()
        this.form.company = ""
        this.form.content = ""
        this.form.mail = ""
        this.form.mobile = ""
        this.form.name = ""
    },
    // 导航跳转
    go(index) {
      this.$router.push(index);
    },
  }
};
</script>
<style scoped lang="scss">
.home {
  .swiper-container {
    max-width: 1920px;
    min-width: 1200px;
    cursor: pointer;
    height: auto;
    img {
      width: 100%;
      // height: 100%;
    }
    /deep/ .swiper-slide {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    /deep/ .swiper-pagination-bullet {
      border-radius: 0;
    }
  }
  .pro-container {
    text-align: center;
    h1 {
      font-size: $font-size-32;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      padding-top: 70px;
      padding-bottom: 25px;
    }
    > .line {
      display: inline-block;
      width: 60px;
      height: 2px;
      background: #1F71FF;
      margin-bottom: 40px;
    }
    h2 {
      font-size: $font-size-20;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #707070;
      padding-bottom: 60px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
      padding: 70px 0 88px;
      .box {
        width: 300px;
        height: 400px;
        cursor: pointer;
        text-align: center;
        position: relative;
        .line {
          display: block;
          width: 40px;
          height: 2px;
          background: #1F71FF;
          margin: 0 auto;
          margin-bottom: 20px;
        }
        .title {
          font-size: $font-size-20;
          font-family: Source Han Sans CN;
          font-weight: 800;
          line-height: 30px;
          color: #464646;
          padding-bottom: 40px
        }
        .des {
          font-size: $font-size-14;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 25px;
          color: #707070;
          // width: 300px;
          padding: 0 25px;
          margin: 0 auto;
        }
        img {
          // width: 94px;
          // height: 64px;
          margin-bottom: 32px;
        }
        .more{ 
          opacity: 0;
          position: absolute;
          bottom: 0;
          width: 100%;
          padding-bottom: 5px;
          font-size: 14px;
          font-family: Arial;
          font-weight: 400;
          line-height: 30px;
          color: #1F71FF;
          transition: all .75s ease;
        }

        .more:after,
        .more:before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 100%;
          z-index:-2;
        }

        &:hover .more{
          opacity:1;
          z-index:1;
        }            
      
        .more:before {
          opacity:1;
          transition: .5s;
          border-bottom: 2px solid #1F71FF;
          z-index:-1;
        }          

        &:hover .more:after,
        &:hover .more:before {
          width: 100%;
        }
      }
    }
  }
  .business-container {
    max-width: 1920px;
    background: #F9FBFF;
    padding: 55px 0 74px;
    margin: 0 auto;
    h1 {
      font-size: $font-size-32;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      text-align: center;
      padding-bottom: 25px;
    }
    > .line {
      display: block;
      width: 60px;
      height: 2px;
      background: #1F71FF;
      margin: 0 auto;
      margin-bottom: 90px;
    }
    .content {
      display: flex;
      width: 1200px;
      margin: 0 auto;
      // justify-content: space-between;
      .box {
        width: 240px;
        height: 450px;
        background: #fff;
        text-align: center;
        img {
          margin-top: 44px;
        }
        .line {
          display: block;
          width: 40px;
          height: 2px;
          background: #1F71FF;
          margin: 0 auto;
          margin-top: 45px;
        }
        .title {
          font-size: $font-size-20;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #464646;
          padding-top: 20px;
          padding-bottom: 45px;
        }
        .des {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #707070;
          text-align: left;
          line-height: 30px;
          padding-left: 17px;
        }
      }
      .blue-bg {
        background: #DAEFFF;
      }
    }
  }
  .brand-container {
    text-align: center;
    width: 1200px;
    margin: 0 auto;
    h1 {
      font-size: $font-size-32;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      padding-bottom: 25px;
      padding-top: 70px;
    }
    > .line {
      display: block;
      width: 60px;
      height: 2px;
      background: #1F71FF;
      margin: 0 auto;
      margin-bottom: 40px;
    }
    h2 {
      font-size: $font-size-20;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #707070;
      padding-bottom: 60px;
    }
    .content {
      .box {
        display: flex;
        .item {
          width: 256px;
          position: relative;
          height: 140px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          span {
            position: absolute;
            top: 47px;
            right: 0;
            display: inline-block;
            width: 1px;
            height: 60px;
            background: #D9D9D9;
          }
        }
      }
    }
  }
  .btn-container {
    display: flex;
    width: 1200px;
    margin: 110px auto 0;
    justify-content: center;
    padding-bottom: 80px;
    .btn-customer {
      width: 170px;
      height: 50px;
      background: #1F71FF;
      border-radius: 40px;
      font-size: $font-size-20;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 50px;
      color: #FFFFFF;
      text-align: center;
      cursor: pointer;
      margin-right: 30px;
    }
    .btn-business {
      width: 274px;
      height: 50px;
      border-radius: 40px;
      line-height: 50px;
      text-align: center;
      background: #FFFFFF;
      border: 1px solid #1F71FF;
      font-size: $font-size-20;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #1F71FF;
      cursor: pointer;
    }
  }
}

/deep/ .el-form-item__content {
  display: flex;
  span {
    color: red;
    padding-right: 10px;
  }
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #D9D9D9;
}

/deep/ .el-dialog__body {
  padding: 30px 20px 0;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  span {
    position: absolute;
    right: 165px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    line-height: 20px;
    color: #FF0000;
    display: inline-block;
    width: 161px;
  }
  /deep/ .el-button--primary {
    width: 130px;
    // height: 50px;
    // background: #1F71FF;
    border-radius: 40px;
    // font-size: $font-size-20;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
  }
}

/deep/ .el-form-item__error {
  left: 17px;
}

/deep/ .el-input__inner {
  font-family: Source Han Sans CN;
}
/deep/ .el-textarea__inner {
  font-family: Source Han Sans CN;
}
</style>


// WEBPACK FOOTER //
// src/view/home/index.vue